import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { tap } from 'rxjs/operators';
import { ToastService } from '../../../../../main/services';
import { SuppliersService } from '../../../../services';

@Component({
    selector: 'jft-import-contacts-modal',
    templateUrl: './import-contacts-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportContactsModalComponent {

    public loading: boolean = false;
    public loadingTemplate: boolean = false;

    constructor(
        private toast: ToastService,
        private activeModal: NgbActiveModal,
        private supplierService: SuppliersService
    ) {
    }

    public close() {
        this.activeModal.dismiss();
    }

    public downloadTemplate($event: Event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.loadingTemplate) {
            return;
        }
        this.loadingTemplate = true;

        this.supplierService.downloadContactsTemplate().subscribe((response: Blob) => {
            // FileSaver, as downloadSupplierContacts does: revoking the object
            // URL right after link.click() aborts the download in some browsers.
            FileSaver.saveAs(response, 'JFT - Import Contacts Template.xlsx');
            this.loadingTemplate = false;
        }, () => {
            this.loadingTemplate = false;
        });
    }

    public filesSelected(files: File[]) {
        if (!files.length) {
            return;
        }

        this.loading = true;
        this.supplierService.importContacts(files[0])
            .pipe(tap(() => this.loading = false))
            .subscribe((data: any) => {
                // A 200 can still carry per-row failures: the rows that worked
                // are committed, so show the summary and every error, and close
                // either way so the contact list refreshes.
                const errors = (data && data.errors) || [];
                if (errors.length) {
                    this.toast.warning(data.details, '');
                    errors.forEach((message: string) => this.toast.error(message, ''));
                } else {
                    this.toast.success(data.details);
                }
                this.activeModal.close(true);
            }, (err) => {
                this.loading = false;
                const details = err.error && err.error.details;
                if (Array.isArray(details)) {
                    details.forEach(message => this.toast.error(message, ''));
                } else if (details) {
                    this.toast.error(details, '');
                } else {
                    this.toast.error('Import failed. Please check the file and try again.', '');
                }
            });
    }
}
